<template>

  <div
    class="meet-main"
    :class="meetMainViewport">
    <div
      class="meet-main-iframe"
      ref="iframe"></div>
    <div class="meet-main-actions bg-dark">
      <button
       class="btn btn-dark"
       :class="{ 'btn-outline-light': meetMainViewport === 'fullscreen' }"
       @click="changeViewport('fullscreen')">
       <i class="fa-solid fa-expand"></i> Expandir
      </button>
      <button
       class="btn btn-dark"
       :class="{ 'btn-outline-light': meetMainViewport === 'divided' }"
       @click="changeViewport('divided')">
       <i class="fa-solid fa-table-columns"></i> Dividir
      </button>
      <button
       class="btn btn-danger"
       @click="close()">
       <i class="fa-solid fa-phone"></i>
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'MeetMain',
  components: {
  },
  data () {
    return {
      api: null
    }
  },
  computed: {
    meetMainToken () {
      return this.$store.getters.getMeetMain.token
    },
    meetMainViewport () {
      return this.$store.getters.getMeetMain.viewport
    },
    me () {
      return this.$store.getters.getMe
    }
  },
  mounted () {
    this.api = new window.JitsiMeetExternalAPI('8x8.vc', {
      lang: this.me.locale,
      roomName: `vpaas-magic-cookie-9fef128db54248398f7d405cb10e501b/${this.meetMainToken}`,
      // parentNode: document.querySelector('#jaas-container'),
      parentNode: this.$refs.iframe,
      userInfo: {
        // email: 'email@jitsiexamplemail.com',
        displayName: this.me.name
      },
      configOverwrite: {
        enableNoisyMicDetection: false,
        subject: 'Reunião'
      },
      interfaceConfigOverwrite: {
        SHOW_PROMOTIONAL_CLOSE_PAGE: false,
        // HIDE_DEEP_LINKING_LOGO: true,
        // SHOW_BRAND_WATERMARK: false,
        LANG_DETECTION: true,
        // SHOW_JITSI_WATERMARK: false,
        // SHOW_WATERMARK_FOR_GUESTS: false,
        SHOW_CHROME_EXTENSION_BANNER: false,
        TOOLBAR_BUTTONS: [
          'microphone',
          'camera',
          'closedcaptions',
          'desktop',
          'fullscreen',
          'fodeviceselection',
          '-hangup',
          'profile',
          'chat',
          'settings',
          'filmstrip',
          'invite',
          'shortcuts',
          'tileview',
          'download',
          'mute-everyone'
        ]
      }
      // Make sure to include a JWT if you intend to record,
      // make outbound calls or use any other premium features!
      // jwt: 'eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtOWZlZjEyOGRiNTQyNDgzOThmN2Q0MDVjYjEwZTUwMWIvOWFjZGNjLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJpYXQiOjE2ODc4OTE0MDUsImV4cCI6MTY4Nzg5ODYwNSwibmJmIjoxNjg3ODkxNDAwLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtOWZlZjEyOGRiNTQyNDgzOThmN2Q0MDVjYjEwZTUwMWIiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJoaWRkZW4tZnJvbS1yZWNvcmRlciI6ZmFsc2UsIm1vZGVyYXRvciI6dHJ1ZSwibmFtZSI6IndpbGxpYW0uY29lbGhvIiwiaWQiOiJnb29nbGUtb2F1dGgyfDExODE4NzM1MTA2MzM2OTkxMDc2OCIsImF2YXRhciI6IiIsImVtYWlsIjoid2lsbGlhbS5jb2VsaG9AcXVpY2tpbi5pbyJ9fSwicm9vbSI6IioifQ.Gp_gkBZR03G067HaKdgBNlyIIdqeppw3aOctPtgRxcZIt8XXiIYjQWZQwn5WVIlaYtQZuauGk9fpIU8woi6PKIXA6BoGKyORFwUUFQevLlAZ6EyiHdPkea7Kfst5z9_qhMyJJoEAxdr3FlNsCSepFfeK9vFFvSE8wRMgFEGQKFIjQNrBGPjIm9gVRiX-xWL55cSg0JhQoCjCIfmL_1vCSWXEbog5CGQqTlycCJba7Z74MtGUqjyKt2St44ss32kPsoHL37NTNQtUx90lTvTLJqRED4pNPxFgxV1EONObpWESRSVXnuZWnGzOip1VVVbVjUzFcys1tZdy4WtM2wlN-A'
    })
  },
  methods: {
    changeViewport (value) {
      this.$store.dispatch('updateMeetMain', { viewport: value })
    },
    close () {
      this.$router.push({ query: { ...this.$route.query, meet_token: undefined } }) // remove meet_token
      this.api.executeCommand('hangup') // sair
      this.$store.dispatch('unsetMeetMain', {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.meet-main {
  position: absolute;
  z-index: 99999;
  width: 20%;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
  .meet-main > .meet-main-iframe {
    flex: 1;
  }
  .meet-main > .meet-main-actions {
    padding: 10px;
    text-align: center;
  }
.meet-main.fullscreen {
  width: 100%;
}

@media (max-width: 1097px) {
  .meet-main {
    width: 220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Meet/MeetMain.vue